/*
 * Copyright © 2021 Aram Meem Company Limited.  All Rights Reserved.
 */

import * as React from 'react';
import { withRouter } from "react-router-dom";
import { OrderTracking } from '../models/order-tracking';
import { FooterWithLinks } from '../components/FooterWithLinks';
import { StoreService } from '../store.service';
import { SelectAddressMap } from '../components/SelectAddressMap';
import { DeliveryAddress } from '../models/delivery-address';
import i18n from '../getText';
import { Preloader } from '../components/Preloader';
import { OrderSubHeader } from "../components/OrderSubHeader";
import { storeServiceInstance } from "../App";
import { OrderState } from "../types";

interface Params {
  storeService: StoreService,
  history: any
}

class PageState {
  error: boolean = false;
  message: string = '';
  loaded: boolean = false;
  showModal: boolean = false;
  orderTracking: OrderTracking = null;
  addressLine2: string = '';
  note: string = '';

}


class SelectAddressPage extends React.Component<Params, PageState> {

  constructor(props) {
    super(props);
    this.state = new PageState();
  }

  componentDidMount() {
    this.props.storeService.load()
      .then(orderTracking => {
        if (orderTracking.state !== OrderState.WAIT_CUSTOMER_LOCATION && !localStorage.getItem('debugMod')) {
          this.props.history.replace({pathname: '/'});
        }
        this.setState({orderTracking})
        }
      )
      .catch(error => this.setState(error))
      .then(() => this.setState({loaded: true}));
  }

  setDeliveryAddress = (deliveryAddress: DeliveryAddress) => {
    storeServiceInstance.customerSelectedAddress = true;
    this.state.orderTracking.dropOffAddress = deliveryAddress;
    if (this.state.orderTracking.dropOffAddress.addressLine2 === null) {
      this.state.orderTracking.dropOffAddress.addressLine2 = '';
    }

    if (this.state.orderTracking.dropOffAddress.note === null) {
      this.state.orderTracking.dropOffAddress.note = '';
    }

    this.props.storeService.orderTracking = this.state.orderTracking;

  }

  setAddressLine2 = (event) => {
    this.setState({addressLine2: event.target.value});
  }

  setNote = (event) => {
    this.setState({note: event.target.value});
  }

  handleContinue = (event) => {
    event.preventDefault();
    this.props.storeService.orderTracking = this.state.orderTracking;
    this.props.storeService.orderTracking.dropOffAddress.addressLine2 = this.state.addressLine2;
    this.props.storeService.orderTracking.dropOffAddress.note = this.state.note;

    this.setState({showModal: false});
    this.props.history.replace({pathname: '/confirm-order'});
  }

  render() {

    return (
      <div>
        <article className="site_wrapper has-map">
          <header className="order_header">
            <div className="container">
              <p className="heading ta-c mb-0">
                {i18n.pgettext('SelectAddressPage', 'Select Delivery location')}
              </p>

              {this.state.loaded && !this.state.error && <OrderSubHeader
                number={this.state.orderTracking.number}
                merchant={this.state.orderTracking.merchant}
                totalCost={this.state.orderTracking.totalCost}/>}
            </div>
          </header>
          {this.state.loaded && !this.state.error && <main className="content_wrapper flex_content">
            <div className="map flex_content-inner">
              <SelectAddressMap
                dropOffLocation={this.state.orderTracking.dropOffAddress.geoPoint}
                pickUpGeoPoint={this.state.orderTracking.pickUpGeoPoint}
                setDeliveryAddress={this.setDeliveryAddress}
              />
              <button type="button"
                      onClick={() => this.setState({showModal: true})}
                      className="btn btn-primary btn-block map-bottom_btn">
                {i18n.pgettext('SelectAddressPage', 'Select Delivery location')}
              </button>

            </div>
          </main>}


          {this.state.loaded && this.state.error && <main className="content_wrapper">
            <p className="error_box">{this.state.message}</p>
          </main>}

          {!this.state.loaded && <Preloader/>}

          <FooterWithLinks/>
        </article>
        <div className={'modal-layer anim-fade anim-fade--show' + (this.state.showModal ? '' : ' hidden')}>

          <div className="modal-bg" data-modal-close=""/>
          <div className="modal-wrapper">
            <div className="modal-window">
              <div className="modal-content">
                <p className="heading mb-0 ta-c">{i18n.pgettext('SelectAddressPage', 'Additional info')}</p>
                <p className="sub_heading ta-c">{i18n.pgettext('SelectAddressPage', 'Optional')}</p>
                <form>
                  <div className="form_group">
                    <input className="input"
                           value={this.state.addressLine2}
                           onChange={this.setAddressLine2}
                           placeholder={i18n.pgettext('SelectAddressPage', 'Apartment/Building Number')}/>
                  </div>
                  <div className="form_group">
                      <textarea rows={3}
                                value={this.state.note}
                                onChange={this.setNote}
                                className="input"
                                placeholder={i18n.pgettext('SelectAddressPage', 'Comment for Driver')}/>
                  </div>
                  <button
                    onClick={this.handleContinue}
                    className="btn btn-primary btn-block mt-2">
                    {i18n.pgettext('SelectAddressPage', 'Continue')}
                  </button>
                </form>
              </div>
            </div>
          </div>

        </div>


      </div>
    );

  }
}

export default withRouter(SelectAddressPage);



// WEBPACK FOOTER //
// ./src/app/pages/SelectAddressPage.tsx